import {VehicleOwnershipEnum} from '@/services/api-clients';

export function driverVehicleOwnershipIconColorFilter(type: VehicleOwnershipEnum) {
  switch(type) {
    case VehicleOwnershipEnum.OwnedOrRented: return 'blue-grey';
    case VehicleOwnershipEnum.RentedFromCarrier: return 'info';
    case VehicleOwnershipEnum.OwnedByCarrier: return 'warning';
  }
}
